import type { BuildCanvasQueryKeyParams } from '../types';

// Single source for react-query cache keys across all canvas hooks. Stable
// strings so writes can invalidate the exact affected reads (see roadmap).
const buildCanvasQueryKey = ({
    scope,
    organizationId,
    canvasId,
    filter,
    itemId,
    threadId,
    query,
}: BuildCanvasQueryKeyParams): string => {
    switch (scope) {
        case 'list':
            // The optional `query` carries the origin/kind/name-search signature so
            // changing a narrow keys a distinct cache entry (and refetches).
            return query
                ? `canvas-list-${organizationId}-${filter}-${query}`
                : `canvas-list-${organizationId}-${filter}`;
        case 'canvas':
            return `canvas-${canvasId}`;
        case 'items':
            return `canvas-items-${canvasId}`;
        case 'connections':
            return `canvas-connections-${canvasId}`;
        case 'activity':
            return `canvas-activity-${canvasId}`;
        case 'viewers':
            return `canvas-viewers-${canvasId}`;
        case 'item-url':
            return `canvas-item-url-${canvasId}-${itemId}`;
        case 'item-content':
            return `canvas-item-content-${canvasId}-${itemId}`;
        case 'item-conversation':
            return `canvas-item-conversation-${canvasId}-${itemId}`;
        case 'item-rubric':
            return `canvas-item-rubric-${canvasId}-${itemId}`;
        case 'item-site':
            return `canvas-item-site-${canvasId}-${itemId}`;
        case 'item-site-log':
            return `canvas-item-site-log-${canvasId}-${itemId}`;
        case 'item-actions':
            return `canvas-item-actions-${canvasId}-${itemId}`;
        case 'thread':
            return `canvas-thread-${threadId}`;
        case 'search':
            return `canvas-search-${organizationId}-${query}`;
        default: {
            const exhaustiveCheck: never = scope;
            return exhaustiveCheck;
        }
    }
};

export default buildCanvasQueryKey;
